import { TextField, TextFieldProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface GeneratorRelayThresholdFieldProps extends Omit<TextFieldProps, 'value'> {
  value?: number | string | null
}

export default function GeneratorRelayThresholdField({
  value,
  label,
  onChange,
  select,
  ...props
}: GeneratorRelayThresholdFieldProps) {
  const { t } = useTranslation('generator')

  return (
    <TextField
      type={select ? undefined : 'number'}
      select={select}
      value={value ?? ''}
      label={label ?? `${t('threshold')} (%)`}
      {...props}
      onChange={onChange}
    />
  )
}
